import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Images
import brandDark from "assets/images/somosure/logo.png";

import { getSingleTransaction } from "actions/transactionActions";
import MDStatusStepper from "components/MDStatusStepper";
import PaymentMethod from "layouts/transaction-management-details/PaymentMethod";

function TransactionManagementDetails() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const singleTransaction = useSelector((state) => state.singleTransaction);
  const { transactionSingle } = singleTransaction;

  useEffect(() => {
    dispatch(getSingleTransaction(id));
  }, [dispatch, id]);

  return (
    <DashboardLayout>
      <DashboardNavbar
        title={`${transactionSingle?.client?.name}'s Transaction Details`}
      />
      <MDBox mt={6} mb={6}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={5} lineHeight={0}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      component="img"
                      src={brandDark}
                      alt="Brand"
                      width="9rem"
                    />
                  </MDBox>

                  <MDBox display="flex" alignItems="center">
                    <MDBox
                      component="img"
                      src={transactionSingle?.client?.profile_image}
                      alt="Brand"
                      width="5rem"
                    />
                  </MDBox>
                </MDBox>

                <MDBox display="flex" justifyContent="space-between" mb={3}>
                  <MDBox>
                    <MDTypography variant="h6">
                      Vertical Lakes Fisheries
                    </MDTypography>
                    <MDTypography variant="h6">Nairobi, Kenya</MDTypography>
                    <MDTypography variant="h6">
                      Email:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        verticallakes@mail.com
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Phone:{" "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        +254 700 112344
                      </MDTypography>
                    </MDTypography>
                  </MDBox>

                  <MDBox textAlign="right">
                    <MDTypography variant="h6">
                      Name:{"  "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {transactionSingle?.client?.name}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Email:{"  "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {transactionSingle?.client?.email}
                      </MDTypography>
                    </MDTypography>
                    <MDTypography variant="h6">
                      Phone:{"  "}
                      <MDTypography
                        variant="button"
                        color="text"
                        fontWeight="regular"
                      >
                        {transactionSingle?.client?.phone}
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                </MDBox>

                <Divider />

                <Grid container spacing={3} justifyContent="center">
                  <Grid item xs={12} sm={12} md={3} ld={3}>
                    <MDTypography
                      pt={2}
                      px={2}
                      py={2}
                      variant="h6"
                      fontWeight="medium"
                    >
                      Payment Status
                    </MDTypography>
                    <MDBox display="flex" flexDirection="row">
                      <MDBox>
                        <MDStatusStepper transaction={transactionSingle} />
                      </MDBox>
                      <MDBox>
                        <Divider orientation="vertical" sx={{ ml: 1, mr: 1 }} />
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={5} ld={5}>
                    <MDTypography
                      pt={2}
                      px={2}
                      py={2}
                      variant="h6"
                      fontWeight="medium"
                    >
                      Payment Details
                    </MDTypography>
                    <MDBox display="flex" flexDirection="row">
                      <MDBox>
                        <PaymentMethod
                          phone={transactionSingle?.client?.phone}
                        />
                        <MDBox display="flex" flexDirection="column">
                          <MDBox my={2}>
                            <MDTypography variant="h6">Order No.</MDTypography>
                            <MDTypography
                              variant="button"
                              color="text"
                              fontWeight="regular"
                            >
                              #{transactionSingle?._id}
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <MDTypography variant="h6">
                              Transaction Code:
                            </MDTypography>
                            <MDTypography
                              variant="button"
                              color="text"
                              fontWeight="regular"
                            >
                              #{transactionSingle?.transactionCode}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox textAlign="left" my={2}>
                          <MDTypography variant="h6">
                            Transaction Made on:{" "}
                            <MDTypography
                              variant="button"
                              color="text"
                              fontWeight="regular"
                            >
                              {moment(transactionSingle?.created_at).format(
                                "DD/MM/YYYY"
                              )}
                            </MDTypography>
                          </MDTypography>
                          <MDTypography variant="h6">
                            Through:{" "}
                            <MDTypography
                              variant="button"
                              color="text"
                              fontWeight="regular"
                            >
                              {transactionSingle?.transactionMethod}
                            </MDTypography>
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                      <MDBox>
                        <Divider orientation="vertical" sx={{ ml: 5, mr: 1 }} />
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} ld={4}>
                    <MDBox textAlign="left" my={2}>
                      <MDTypography
                        pt={2}
                        px={10}
                        py={2}
                        variant="h6"
                        fontWeight="medium"
                      >
                        Payment Summary
                      </MDTypography>
                      <MDBox
                        textAlign="right"
                        my={2}
                        display="flex"
                        flexDirection="column"
                      >
                        <MDTypography variant="h6">
                          Total Order Amount:{" "}
                        </MDTypography>
                        <MDTypography
                          variant="button"
                          color="text"
                          fontWeight="regular"
                        >
                          Ksh. {transactionSingle?.order?.computedAmount}
                        </MDTypography>

                        <MDTypography variant="h6" mt={2}>
                          Transaction Amount Paid:{" "}
                        </MDTypography>
                        <MDTypography
                          variant="button"
                          color="text"
                          fontWeight="regular"
                        >
                          Ksh. {transactionSingle?.amount}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default TransactionManagementDetails;
